import { ProductService } from '@app/api/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from '@app/api/brand.service';
import { BrandHomeService } from '@app/api/brandHome.service';
import { ManufacturerService } from '@app/api/manufacturer.service';
import {
  Component,
  HostListener,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ProductFilterComponent } from '@app/views/partials/layout/product-filter/product-filter.component';
import { Route } from '@angular/compiler/src/core';
import { environment } from '@app/../environments/environment';
import { UtilService } from '@app/services/util.service';

@Component({
  selector: 'meu-app-search-result',
  templateUrl: './app-search-result.component.html',
  styleUrls: ['./app-search-result.component.scss'],
})
export class AppSearchResultComponent implements OnChanges, OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private ref: ChangeDetectorRef,
    private brandService: BrandService,
    private brandHomeService: BrandHomeService,
    private manuService: ManufacturerService
  ) {}
  /*for admin page component app-order-detail-add-product*/
  @Input() searchStr: string;
  @Output() productIdEmit: EventEmitter<any> = new EventEmitter();
  @Input() showOnAdminPage = false;
  @ViewChild(ProductFilterComponent, { static: false }) productFilter: ProductFilterComponent;
  /*-----------------------*/
  minPrice: number | null = null;
  maxPrice: number | null = null;
  originalProductList: any[] = [];
  originalProductListAvailable: any[] = [];
  showFilter = true;
  totalProduct: any = 0;
  pagesize: any = 24;
  pageIndex: any = 1;
  totalProductAvailable: any = 0;
  pagesizeAvailable: any = 24;
  pageIndexAvailable: any = 1;
  loading: boolean = false;
  listProduct: any = [1, 2, 3, 4, 5, 6, 7];
  lstProductSearch: any = [];
  lstProductSearchAvailable: any = [];
  valueSearch: any = '';
  environment: any = environment;
  lstbrandHome: any = [];
  lstmanufacturer: any = [];
  pageSizeOptions: number[] = [24, 36, 48];

  selectedBrandIds: string[] = [];
  selectedManufacturerIds: string[] = [];
  isNew: boolean = true;
  isCategoryOpen = false;
  isCategoryBrand = false;

  isListLayout: true;
  sortValue: string = '';

  sorts: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (this.searchStr != undefined && this.searchStr != null) {
      this.valueSearch = this.searchStr;
      this.search(this.valueSearch);
      this.searchAvailable(this.valueSearch);
    }
  }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.valueSearch = params.search;
      this.search(this.valueSearch);
      this.searchAvailable(this.valueSearch);
    });
    this.getBrand();
    this.getManufacturer();
  }


  onSortChange(value: string) {
    this.sorts = value === 'asc' ? 'price' : '-price';

    this.search(this.valueSearch);
    this.searchAvailable(this.valueSearch);
    // if (value === 'asc') {
    //   this.lstProductSearch = [...this.lstProductSearch].sort((a, b) => a.price - b.price);
    //   this.lstProductSearchAvailable = [...this.lstProductSearchAvailable].sort(
    //     (a, b) => a.price - b.price
    //   );
    // } else if (value === 'desc') {
    //   this.lstProductSearch = [...this.lstProductSearch].sort((a, b) => b.price - a.price);
    //   this.lstProductSearchAvailable = [...this.lstProductSearchAvailable].sort(
    //     (a, b) => b.price - a.price
    //   );
    // }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const width = (event.target as Window).innerWidth;
    if (width > 1280 && this.productFilter && this.productFilter.filter) {
      this.productFilter.filterShow();
    }
  }

  toggleView(value) {
    this.isListLayout = value;
  }
  filterShow() {
    if (this.productFilter) {
      this.productFilter.filterShow();
    }
  }
  search(valueSearch) {
    this.productService
      .apiProductsSearchsGet(
        valueSearch,
        'is_hidden==false',
        `${this.sorts}`,
        this.pageIndex,
        this.pagesize,
        this.selectedBrandIds,
        this.selectedManufacturerIds,
        null,
        this.minPrice,
        this.maxPrice
      )
      .subscribe((res) => {
        if (res.success == true) {
          this.lstProductSearch = res.data.collection;
          // this.pageIndex = res.data.pageIndex;
          // this.pagesize = res.data.pagesize;
          console.log(res.data.total);

          this.totalProduct = res.data.total;
          for (let i = 0; i < this.lstProductSearch.length; i++) {
            this.lstProductSearch[i].seo_name = UtilService.slugify(this.lstProductSearch[i].name);
            this.lstProductSearch[i].default_image =
              this.environment.backendhost + this.lstProductSearch[i].default_image;
            this.lstProductSearch[i].percentdiscount = this.calculatePercentPrice(
              this.lstProductSearch[i].price,
              this.lstProductSearch[i].origin_price
            );
          }
          if (this.originalProductList.length === 0) {
            this.originalProductList = this.lstProductSearch.slice();
          }
          this.lstProductSearch = this.lstProductSearch.slice();
          this.ref.detectChanges();
        }
      });
  }
  searchAvailable(valueSearch) {
    this.productService
      .apiProductsSearchsGet(
        valueSearch,
        'is_hidden==false',
        `${this.sorts}`,
        this.pageIndexAvailable,
        this.pagesizeAvailable,
        this.selectedBrandIds,
        this.selectedManufacturerIds,
        null,
        this.minPrice,
        this.maxPrice
      )
      .subscribe((res) => {
        if (res.success == true) {
          this.lstProductSearchAvailable = res.data.collection;
          // this.pageIndexAvailable = res.data.pageIndex;
          // this.pagesizeAvailable = res.data.pagesize;
          this.totalProductAvailable = res.data.total;
          for (let i = 0; i < this.lstProductSearchAvailable.length; i++) {
            this.lstProductSearchAvailable[i].seo_name = UtilService.slugify(
              this.lstProductSearchAvailable[i].name
            );
            this.lstProductSearchAvailable[i].default_image =
              this.environment.backendhost + this.lstProductSearchAvailable[i].default_image;
            this.lstProductSearchAvailable[i].percentdiscount = this.calculatePercentPrice(
              this.lstProductSearchAvailable[i].price,
              this.lstProductSearchAvailable[i].origin_price
            );
          }
          if (this.originalProductListAvailable.length === 0) {
            this.originalProductListAvailable = this.lstProductSearchAvailable.slice();
          }
          this.lstProductSearchAvailable = this.lstProductSearchAvailable.slice();
          this.ref.detectChanges();
        }
      });
  }

  onPageChangeAll(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.search(this.valueSearch);
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChangeAll(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.search(this.valueSearch);
  }

  onPageChangeAvailable(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndexAvailable = pageNumber;
      this.searchAvailable(this.valueSearch);
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChangeAvailable(newSize: number) {
    this.pagesizeAvailable = newSize;
    this.pageIndexAvailable = 1;
    this.searchAvailable(this.valueSearch);
  }

  ngOnDestroy() {}

  onFilterChange() {
    this.pageIndex = 1;
    this.pageIndexAvailable = 1;

    this.search(this.valueSearch);
    this.searchAvailable(this.valueSearch);
  }

  onFilterChangeFromComponent(event: { brandIds: string[]; manufacturerIds: string[] }) {
    this.selectedBrandIds = event.brandIds;
    this.selectedManufacturerIds = event.manufacturerIds;
    this.onFilterChange();
  }

  calculatePercentPrice(price, originPrice) {
    if (originPrice == 0) return 0;
    let percent = 0;
    percent = Math.round(100 - (price / originPrice) * 100);
    return percent;
  }
  selectProduct(productId, seoName) {
    if (this.searchStr || this.showOnAdminPage) {
      this.productIdEmit.emit(productId);
    } else {
      this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
    }
  }

  getBrand() {
    this.brandService.apiBrandsGet('', '', 1, 1000).subscribe((res) => {
      if (res.success) {
        this.lstbrandHome = res.data.collection;
      }
    });
  }
  getManufacturer() {
    this.manuService.apiManufacturerGet('', '', 1, 360).subscribe((res) => {
      if (res.success) {
        this.lstmanufacturer = res.data.collection;
      }
    });
  }
  allowOnlyNumber(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  filterByPrice() {
    const min = this.minPrice != null ? Number(this.minPrice) : 0;
    const max = this.maxPrice != null ? Number(this.maxPrice) : Infinity;
    this.search(this.valueSearch);
    this.searchAvailable(this.valueSearch);
    // const filterByRange = (list: any[]) =>
    //   list.filter((item) => Number(item.price) >= min && Number(item.price) <= max);
    // this.lstProductSearch = filterByRange(this.originalProductList);
    // this.lstProductSearchAvailable = filterByRange(this.originalProductListAvailable);
    this.ref.detectChanges();
  }
  resetFilter() {
    this.minPrice = null;
    this.maxPrice = null;
    this.selectedBrandIds = [];
    this.selectedManufacturerIds = [];
    this.lstProductSearch = this.originalProductList.slice();
    this.lstProductSearchAvailable = this.originalProductListAvailable.slice();
    this.search(this.valueSearch);
    this.searchAvailable(this.valueSearch);
    this.ref.detectChanges();
  }
}
